export const hjSuppressDirective = {
    mounted(el) {
        el.setAttribute('data-hj-suppress', '')
    },
}
